module.exports = __webpack_public_path__ + "img/60.d651f915.jpg";